import clsx from 'clsx';
import { CAROUSEL_LABELS } from '../approvalCarousel.definitions';
import type { CarouselDotsProps } from '../approvalCarousel.types';

export function CarouselDots({ pageCount, page, onSelect }: CarouselDotsProps) {
    return (
        <div className="flex items-center gap-1.5">
            {Array.from({ length: pageCount }, (_, index) => (
                <button
                    key={index}
                    type="button"
                    onClick={() => onSelect(index)}
                    aria-label={CAROUSEL_LABELS.page(index + 1, pageCount)}
                    aria-current={index === page ? 'true' : undefined}
                    className={clsx(
                        'h-2 rounded-full transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                        index === page
                            ? 'w-6 bg-primary-500'
                            : 'w-2 bg-primary-200 hover:bg-primary-300'
                    )}
                />
            ))}
        </div>
    );
}

export default CarouselDots;
